module.exports = __webpack_public_path__ + "static/img/12.a0d2e98.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/sp/12.png
// module id = 31tA
// module chunks = 0